import React, { useRef } from 'react'
import { useReactToPrint } from 'react-to-print'
import { Printer } from 'react-feather'
import { Box, IconButton } from '@material-ui/core'

type Props = {
  children: React.ReactElement | React.ReactElement[]
}

export function Printable({ children }: Props): React.ReactElement {
  const printableComponentRef = useRef<HTMLDivElement>(null)
  const handlePrint = useReactToPrint({
    content: () => printableComponentRef.current,
  })

  return (
    <Box position="relative">
      <Box p={3} position="absolute" right={0}>
        <IconButton onClick={handlePrint}>
          <Printer />
        </IconButton>
      </Box>
      <div ref={printableComponentRef}>{children}</div>
    </Box>
  )
}
